<template>
  <div class="modal-wrapper d-inline-flex flex-wrap">
    <div class="modal-title text-start d-flex justify-content-between">
      <h4 class="text-left d-inline-flex">
        {{ t("message['" + library + "']") }}
      </h4>
      <p class="d-inline-flex" @click="$emit('close')" style="cursor: pointer">
        X
      </p>
    </div>
    <div
      v-for="(img, index) in imgLib"
      :key="'imgidx_' + index"
      style="cursor: pointer"
      @click="updateBtnImg(img)"
    >
      <img :src="imgURL(img)" class="p-1" alt="" height="50" width="50" />
      <!-- kind of hacky -->
      <inline-svg
        style="display: none"
        :id="img"
        :src="imgURL(img)"
        height="50px"
        width="50px"
      ></inline-svg>
    </div>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import { useStore } from "vuex";
import { ref, onBeforeMount, computed, onUpdated } from "vue";
import image64 from "@/modules/image64";
import { useI18n } from "vue-i18n";
export default {
  props: { library: String },
  components: { InlineSvg },
  setup(props) {
    const { t } = useI18n();
    const img = computed(() => store.getters.imgs);
    const selectedBtns = computed(() => store.getters.selectedButtons);
    const inlayBtns = computed(() => store.getters.currentInlayBtns);
    const store = useStore();
    const imgLib = ref([]);
    onBeforeMount(() => {
      imgLib.value.splice(0, imgLib.value.length, ...img.value[props.library]);
    });
    onUpdated(() => {
      imgLib.value.splice(0, imgLib.value.length, ...img.value[props.library]);
    });
    function imgURL(img) {
      return process.env.BASE_URL + "images/icons/" + img;
    }
    function updateBtnImg(img) {
      for (let btn in selectedBtns.value) {
        if (img.length > 0) {
          image64(
            document.getElementById(img),
            (base64Img) => {
              inlayBtns.value[selectedBtns.value[btn]].style.image[
                "background-image"
              ] = "url('" + base64Img + "')";
              inlayBtns.value[selectedBtns.value[btn]].style.image[
                "background-size"
              ] = "30%, cover";
            },
            "image/svg+xml"
          );
        }
      }
      store.dispatch("saveInlay");
    }
    return {
      imgURL,
      imgLib,
      updateBtnImg,
      t,
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-title {
  height: 50px;
  width: inherit;
  padding: 10px;
  line-height: 30px;
  border-bottom: 2px solid #ffde00;
  background-color: #f5f5f5;
}
@media (min-width: 2000px) {
  .modal-wrapper {
    top: 20% !important;
    left: 13% !important;
  }
}
@media (min-width: 1400px) {
  .modal-wrapper {
    top: 18% !important;
    left: 2% !important;
  }
}
@media (min-width: 768px) {
  .modal-wrapper {
    top: 22%;
    left: 1%;
    // width: 210px !important;
  }
}
.modal-wrapper {
  background: #ffffff;
  min-height: 50px;
  width: 360px;
  position: fixed;

  z-index: 1000;
  box-shadow: 0px 17px 21px 2px rgb(227 227 227 / 55%);
  -webkit-box-shadow: 0px 17px 21px 2px rgb(227 227 227 / 55%);
  -moz-box-shadow: 0px 17px 21px 2px rgba(227, 227, 227, 0.55);
}
</style>
